import { unsafeCSS, html } from "lit";
import { property, state, query } from "lit/decorators.js";
import { classMap } from "lit/directives/class-map.js";
import { ifDefined } from "lit/directives/if-defined.js";
import { LeafElement } from "../leaf-element.js";
import "../icon/icon.js";
import "../../utilities/events.js";
import "../icon/icon.component.js";
import "lit/directives/unsafe-svg.js";
import "../../utilities/cache-fetch.js";
import "../../utilities/watch.js";
import "../icon/library.js";
import "../icon/iconset.system.js";
const styles = "/*------------------------------------*\\\n    #RESET\n\\*------------------------------------*/\n/**\n * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/\n */\n*,\n::slotted(*),\n*:before,\n*:after {\n  box-sizing: border-box;\n}\n\n:host *,\n:host *::before,\n:host *::after {\n  box-sizing: inherit;\n}\n\n[hidden] {\n  display: none !important;\n}\n\n/*------------------------------------*\\\n    #ACCORDION-PANEL\n\\*------------------------------------*/\n:host {\n  border-top: calc(var(--leaf-spacing-2) / 2) solid var(--leaf-color-border-brand-subtle);\n  border-radius: 0;\n  display: block;\n  font-family: var(--leaf-typography-body-default-font-family);\n}\n:host slot:not([name]) {\n  display: inline-block;\n}\n\n.leaf-c-accordion-panel {\n  padding: var(--leaf-spacing-24) 0;\n}\n\n.leaf-c-accordion-panel__body {\n  margin: 0;\n  padding: 0;\n  overflow: hidden;\n  visibility: hidden;\n  transition: height var(--leafdcws-anim-fade-quick) var(--leafdcws-anim-ease), visibility var(--leafdcws-anim-fade-quick) var(--leafdcws-anim-ease);\n}\n.leaf-c-accordion-panel.leaf-is-active .leaf-c-accordion-panel__body {\n  visibility: visible;\n}\n\n.leaf-c-accordion-panel__body-inner {\n  font-size: var(--leaf-typography-label-default-font-size);\n  padding: var(--leaf-spacing-8) var(--leaf-spacing-48) 0 var(--leaf-spacing-8);\n}\n\nleaf-icon {\n  height: var(--leaf-spacing-24);\n  min-height: var(--leaf-spacing-24);\n  min-width: var(--leaf-spacing-24);\n  transition: transform var(--leafdcws-anim-fade-quick) var(--leafdcws-anim-ease);\n  width: var(--leaf-spacing-24);\n}\n.leaf-c-accordion-panel.leaf-is-active leaf-icon {\n  transform: rotate(180deg);\n}\n\n.leaf-c-accordion-panel__icon {\n  align-items: center;\n  background: var(--leaf-color-bg-brand-strong);\n  border-radius: var(--leaf-border-radius-round);\n  color: var(--leaf-color-content-knockout);\n  display: flex;\n  height: var(--leaf-spacing-32);\n  justify-content: center;\n  margin-left: var(--leaf-spacing-8);\n  margin-right: var(--leaf-spacing-2);\n  min-height: var(--leaf-spacing-32);\n  min-width: var(--leaf-spacing-32);\n  width: var(--leaf-spacing-32);\n}\n.leaf-c-accordion-panel.leaf-is-active .leaf-c-accordion-panel__icon {\n  background: var(--leafdcws-color-bg-transparent);\n  border: calc(var(--leaf-spacing-2) / 2) solid var(--leaf-color-border-brand);\n  color: var(--leaf-color-content-brand);\n}\n.leaf-c-accordion-panel.leaf-is-active .leaf-c-accordion-panel__icon:hover {\n  border-color: var(--leaf-color-border-brand-strong);\n  background-color: var(--leaf-color-bg-brand-strong-hover);\n  color: var(--leaf-color-content-knockout);\n}\n\n.leaf-c-accordion-panel__button {\n  color: var(--leaf-color-content-brand-strong);\n  display: flex;\n  align-items: center;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  background-color: var(--leafdcws-color-bg-transparent);\n  border: none;\n  cursor: pointer;\n  justify-content: space-between;\n  padding: var(--leaf-spacing-4) var(--leaf-spacing-8);\n  overflow-x: hidden;\n  transition: color var(--leafdcws-anim-fade-quick) var(--leafdcws-anim-ease);\n  width: 100%;\n}\n.leaf-c-accordion-panel__button ::slotted([slot=header]) {\n  display: contents;\n  font-family: var(--leaf-typography-body-default-font-family) !important;\n  font-size: var(--leaf-font-size-5) !important;\n  margin: 0;\n  pointer-events: none;\n}\n@media (max-width: 47.999rem) {\n  .leaf-c-accordion-panel__button ::slotted([slot=header]) {\n    font-size: var(--leaf-font-size-4) !important;\n  }\n}\n.leaf-c-accordion-panel__button:hover .leaf-c-accordion-panel__icon {\n  border-color: var(--leaf-color-border-brand-strong);\n  background-color: var(--leaf-color-bg-brand-strong-hover);\n  color: var(--leaf-color-content-knockout);\n}\n.leaf-c-accordion-panel__button:focus {\n  border-radius: var(--leaf-border-radius-round);\n  box-shadow: 0 0 0 var(--leaf-spacing-2) var(--leaf-color-border-active-outline);\n  outline: none;\n}\n.leaf-c-accordion-panel__button:focus .leaf-c-accordion-panel__icon {\n  border-color: var(--leaf-color-border-brand-strong);\n  color: var(--leaf-color-content-knockout);\n  background-color: var(--leaf-color-bg-brand-strong-hover);\n}\n\n.leaf-c-accordion-panel__button slot {\n  display: inline;\n  text-align: initial;\n}";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
class LeafAccordionPanel extends LeafElement {
  constructor() {
    super();
    this.togglePanel = this.togglePanel.bind(this);
    this.setPanelHeight = this.setPanelHeight.bind(this);
  }
  get accordionHeaderText() {
    var _a;
    return (_a = this.querySelector('[slot="header"]')) == null ? void 0 : _a.textContent;
  }
  connectedCallback() {
    super.connectedCallback();
    const num = Math.floor(Math.random() * 9e5) + 1e5;
    this.id = this.id || `leaf-accordion-panel-${num}`;
    this.ariaLabelledBy = this.ariaLabelledBy || `leaf-accordion-panel-${num}`;
    this.setPanelHeight();
    if (this.isActive) {
      this.fullyOpen = true;
      this.setPanelHeight();
    }
  }
  async setPanelHeight() {
    var _a, _b;
    await this.updateComplete;
    if (this.isActive && !this.fullyOpen || !this.isActive && this.fullyOpen) {
      this.height = ((_b = (_a = this.shadowRoot) == null ? void 0 : _a.querySelector(".leaf-c-accordion-panel__body-inner")) == null ? void 0 : _b.scrollHeight) + "px";
    } else if (this.isActive && this.fullyOpen) {
      this.height = "auto";
    } else if (!this.isActive && !this.fullyOpen) {
      this.height = "0";
    }
  }
  togglePanel() {
    this.isActive = !this.isActive;
    if (this.isActive) {
      this.setPanelHeight();
      setTimeout(() => {
        this.fullyOpen = true;
        this.setPanelHeight();
      }, 350);
    } else {
      this.setPanelHeight();
      setTimeout(() => {
        this.fullyOpen = false;
        this.setPanelHeight();
      }, 50);
    }
  }
  async updated() {
    await this.updateComplete;
    if (this.accordionHeaderText) {
      this.accordionPanelButton.setAttribute("data-element-text", this.accordionHeaderText);
    }
  }
  render() {
    const componentClassName = {
      "leaf-c-accordion-panel": true,
      "leaf-is-active": this.isActive === true
    };
    return html`
      <div class="${classMap(componentClassName)}">
        <div class="leaf-c-accordion-panel__header">
          <button
            class="leaf-c-accordion-panel__button ${this.isActive ? "leaf-is-active" : ""}"
            aria-expanded="${this.isActive ? true : false}"
            aria-controls="${this.id}-button"
            part="button"
            @click=${this.togglePanel}
          >
            <slot name="header" part="header"></slot>
            <div class="leaf-c-accordion-panel__icon">
              <leaf-icon name="keyboard-arrow-more" part="icon"></leaf-icon>
            </div>
          </button>
        </div>
        <div
          class="leaf-c-accordion-panel__body"
          aria-labelledby="${ifDefined(this.ariaLabelledBy)}"
          aria-hidden="${!this.isActive}"
          id="${this.id}-button"
          role="region"
          part="body"
          style=${"height: " + this.height}
        >
          <div class="leaf-c-accordion-panel__body-inner" part="body-inner">
            <slot></slot>
          </div>
        </div>
      </div>
    `;
  }
}
LeafAccordionPanel.styles = unsafeCSS(styles);
__decorateClass([
  property({ type: Boolean, attribute: "is-active" })
], LeafAccordionPanel.prototype, "isActive", 2);
__decorateClass([
  property({ attribute: "aria-labelledby" })
], LeafAccordionPanel.prototype, "ariaLabelledBy", 2);
__decorateClass([
  state()
], LeafAccordionPanel.prototype, "height", 2);
__decorateClass([
  state()
], LeafAccordionPanel.prototype, "fullyOpen", 2);
__decorateClass([
  query(".leaf-c-accordion-panel__button")
], LeafAccordionPanel.prototype, "accordionPanelButton", 2);
export {
  LeafAccordionPanel
};
//# sourceMappingURL=accordion-panel.component.js.map
